import { render, staticRenderFns } from "./ProductDropdown.vue?vue&type=template&id=3cbf2e84&"
import script from "./ProductDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports